import React, { useState, useEffect } from 'react';
import BulletPointIcon from '../../icons/BulletPointIcon';
// import { ReactComponent as AIIcon } from '../icons/AIIcon.svg';
type GenAIResultViewProps = {
    aiInsight: string;
    isOpen: boolean;
    durationInSeconds?: number; // Optional duration for the entire sequence
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setDreamModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const GenAIResultView: React.FC<GenAIResultViewProps> = ({ setIsOpen, aiInsight: businessAiInsight, setDreamModalIsOpen }) => {
    const benefits = [
        "Discovery and access to shared kitchens.",
        "Funding options.",
        "Compliance and documentations.",
        "Culinary training opportunities."
    ];

    const [aiInsight, setAiInsight] = useState<string>(businessAiInsight);

    // const username = "testuser"
    // const prompt = "What is the best way to market my business?"

    // const { aiInsight } = useGenerateAIInsight(username, prompt);

    // console.log(aiInsight)

    useEffect(() => {
        setAiInsight(businessAiInsight);
    }, [businessAiInsight]);

    return (
        <div className="flex flex-col items-center justify-center p-8 min-h-[300px] mx-auto">
            <div className="text-center mb-6">
                <h2 className="text-[#0A3751] text-2xl font-bold mb-4 flex items-center justify-center gap-2">
                    Business Added Successfully 🎉
                </h2>
                <p className="text-gray-700 mb-2 text-left">
                    Congratulations! Your business has been added, and based on your submissions, it has been classified under the{' '}
                    <span className="text-[#0A3751] font-semibold">Dream Stage</span>.
                </p>
                {!aiInsight && <p className="text-gray-700 mb-4 text-left">The dream stage offers;</p>}
            </div>

            {aiInsight ? (
                <div className="w-full mb-8 max-h-[400px] overflow-y-auto pr-4">
                    <div className="space-y-4">
                        {aiInsight.split('\n').map((line, index) => {
                            if (line.trim().startsWith('-')) {
                                return (
                                    <div key={index} className="flex items-start gap-2">
                                        <div className="w-5 h-5 rounded-full bg-[#5DB6CE] flex items-center justify-center mt-1">
                                            <BulletPointIcon />
                                        </div>
                                        <span className="text-gray-700">{line.trim().substring(1).trim()}</span>
                                    </div>
                                );
                            } else if (line.trim().match(/^\d+\./)) {
                                return (
                                    <div key={index} className="flex items-start gap-2">
                                        {/* <div className="w-5 h-5 rounded-full bg-[#5DB6CE] flex items-center justify-center mt-1">
                                            <BulletPointIcon />
                                        </div> */}
                                        <span className="text-gray-700 font-semibold">{line.trim()}</span>
                                    </div>
                                );
                            } else if (line.trim()) {
                                return (
                                    <p key={index} className="text-gray-700">
                                        {line.trim()}
                                    </p>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
            ) : (
                <ul className="w-full space-y-3 mb-8">
                    {benefits.map((benefit, index) => (
                        <li key={index} className="flex items-center gap-2">
                            <div className="w-5 h-5 rounded-full bg-[#5DB6CE] flex items-center justify-center">
                                <BulletPointIcon />
                            </div>
                            <span className="text-gray-700">{benefit}</span>
                        </li>
                    ))}
                </ul>
            )}

            <div className="w-full space-y-3">
                <button
                    onClick={() => setIsOpen(false)}
                    className="w-full py-3 px-4 bg-[#0A3751] text-white rounded-md hover:bg-[#0A3751]/90 transition-colors border-0 font-bold font-raleway text-[18px]"
                >
                    Go to My Business
                </button>
                <button
                    onClick={() => {
                        setIsOpen(false)
                        setDreamModalIsOpen(true)
                    }}
                    className="w-full py-3 px-4 text-[#0A3751] hover:underline transition-colors text-center border-0 font-semibold font-raleway text-[16px]"
                >
                    Go Back to Form
                </button>
            </div>
        </div>
    );
};

export default GenAIResultView;